export default __webpack_public_path__ + "static/media/envelope-white.72ed8984.svg";